import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { api, metHerkansing, type OmgevingInfo } from './api';
import { Kop, Pagina, Testbalk, Voet } from './componenten/Schil';
import { Groepsmenu } from './componenten/Groepsmenu';
import { Laden } from './componenten/basis';
import { Muur } from './paginas/Muur';
import { WordHeld } from './paginas/WordHeld';
import { Bedankt } from './paginas/Bedankt';
import { Betaalpagina } from './paginas/Betaalpagina';
import { Mijn } from './paginas/Mijn';
import { Inloggen } from './paginas/Inloggen';
import { Tekstpagina } from './paginas/Tekstpagina';
import { NepMollie } from './paginas/NepMollie';
import { Beheerschil } from './paginas/beheer/Beheerschil';
import { Overzicht } from './paginas/beheer/Overzicht';
import { Helden } from './paginas/beheer/Helden';
import { Dossier } from './paginas/beheer/Dossier';
import { Instellingen } from './paginas/beheer/Instellingen';

const NIEMAND: OmgevingInfo = { testmodus: false, lokaal: false, gebruiker: null, heldIngelogd: false, klok: null };

export function App() {
  const [omgeving, zetOmgeving] = useState<OmgevingInfo | null>(null);
  const [bereikbaar, zetBereikbaar] = useState(true);

  const ververs = useCallback(async () => {
    try {
      zetOmgeving(await metHerkansing(() => api.haal<OmgevingInfo>('/api/omgeving')));
      zetBereikbaar(true);
    } catch {
      zetOmgeving(NIEMAND);
      zetBereikbaar(false);
    }
  }, []);

  useEffect(() => {
    void ververs();
  }, [ververs]);

  if (!omgeving) return <Laden />;

  return (
    <BrowserRouter>
      <NaarBoven />
      <Testbalk omgeving={omgeving} />
      <Routes>
        <Route element={<Publiek omgeving={omgeving} />}>
          <Route path="/" element={<Muur />} />
          <Route path="/word-held" element={<WordHeld />} />
          <Route path="/bedankt" element={<Bedankt />} />
          <Route path="/betalen/:token" element={<Betaalpagina />} />
          <Route path="/mijn" element={<Mijn omgeving={omgeving} ververs={ververs} />} />
          <Route path="/inloggen" element={<Inloggen omgeving={omgeving} />} />
          <Route path="/voorwaarden" element={<Tekstpagina sleutel="voorwaarden" titel="Voorwaarden" />} />
          <Route path="/privacy" element={<Tekstpagina sleutel="privacy" titel="Privacyverklaring" />} />
          <Route path="/nepmollie/:id" element={<NepMollie />} />
        </Route>
        <Route path="/beheer" element={<Beheerschil omgeving={omgeving} bereikbaar={bereikbaar} ververs={ververs} />}>
          <Route index element={<Overzicht />} />
          <Route path="helden" element={<Helden />} />
          <Route path="helden/:id" element={<Dossier omgeving={omgeving} />} />
          <Route path="instellingen" element={<Instellingen omgeving={omgeving} ververs={ververs} />} />
          <Route path="instellingen/:tab" element={<Instellingen omgeving={omgeving} ververs={ververs} />} />
        </Route>
        <Route path="*" element={<NietGevonden />} />
      </Routes>
    </BrowserRouter>
  );
}

function Publiek({ omgeving }: { omgeving: OmgevingInfo }) {
  return (
    <>
      <Groepsmenu />
      <Kop omgeving={omgeving} />
      <Outlet />
      <Voet />
    </>
  );
}

function NaarBoven() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function NietGevonden() {
  return (
    <Pagina smal>
      <div className="py-24 text-center">
        <h1 className="text-3xl">Deze pagina bestaat niet.</h1>
        <p className="mt-3 text-inkt-zacht">Misschien is de link verouderd.</p>
        <Navigeer />
      </div>
    </Pagina>
  );
}

function Navigeer() {
  return (
    <p className="mt-6">
      <a href="/" className="knop knop-stil">
        Naar de muur
      </a>
    </p>
  );
}

export { Navigate };
